<template>
  <form @submit.prevent="">
    <z-dialog :show="isVisible" :modal-size="modalSize">
      <template #header>
        <div class="custom-header">
          <div class="row">
            <div class="col-md-11">
              <h4 class="modal-title">
                {{ title }}
              </h4>
            </div>
            <div class="col-md-1">
              <a href="#" class="custom-close" @click="close">
                <i class="fa fa-times"></i>
              </a>
            </div>
          </div>
        </div>
      </template>
      <template #body>
        <div class="hostWrapper">
          <z-tabs v-model="currentUserTab" :tabs="userTabs" @change="setUserTab" />
          <div v-if="currentUserTab === 'Basic'" class="row p-2">
            <div class="col">
              <user-basic ref="user" :is-add="isAdd" :firm="firm" :show-firm="showFirm" @changed="changed"
                @moved="moved" />
            </div>
          </div>
          <div v-if="currentUserTab === 'Locations'" class="row p-2"></div>
        </div>
      </template>
      <template #footer>
        <div class="custom-footer">
          <div class="col-1">
            <span title="firm/user/contact">{{ ids }}</span>
          </div>
          <div class="col">
            <button v-if="!isAdd" type="button" class="btn btn-outline-secondary" :disabled="isSaving"
              @click="changePassword">
              Change Password
            </button>
            <z-message v-model="message" class="alert alert-warning mt-2" />
          </div>
          <div class="col custom-right-align">
            <button type="button" class="btn btn-light" @click="close()">Cancel</button>
            <button v-show="isSave" class="btn btn-danger ms-2" :disabled="isSaving" @click="save(false)">
              <span class="ms-2">Save</span>
            </button>
            <button v-show="isSave" class="btn btn-danger ms-2" :disabled="isSaving" @click="save(true)">
              <span class="ms-2">Save & Close</span>
            </button>
          </div>
        </div>
      </template>
    </z-dialog>
  </form>
</template>
<script>
import { mapState, mapActions } from 'pinia'
import { userStore } from '@/stores/user'
import ZDialog from '@/components/utilities/elements/Dialog.vue'
import ZTabs from '@/components/utilities/elements/Tabs.vue'
import ZMessage from '@/components/utilities/elements/Message.vue'
import UserBasic from './UserBasic.vue'
export default {
  name: 'DialogUser',
  components: {
    ZDialog,
    ZTabs,
    ZMessage,
    UserBasic
  },
  props: {
    modelValue: Object,
    showFirm: Object
  },
  emits: ['closing', 'saved', 'moved', 'changePassword'],
  data() {
    return {
      modalSize: 'modal-xl',
      isSave: false,
      currentUserTab: 'Basic',
      message: null,
      isSaving: false
    }
  },
  computed: {
    ...mapState(userStore, ['user']),
    isVisible() {
      return this.modelValue !== null
    },
    userTabs() {
      let _tabs = ['Basic']
      if (!this.isAdd && this.isInsurer) {
        _tabs.push('Locations')
      }
      return _tabs
    },
    title() {
      let _title = ''
      if (this.modelValue) {
        if (this.modelValue.isAdd) {
          _title = 'Adding User'
        } else {
          _title = `Editing ${this.user.firstName} ${this.user.lastName}`
        }
      }
      return _title
    },
    ids() {
      let _ids = ''
      if (this.modelValue) {
        if (this.modelValue.isAdd) {
          _ids = ''
        } else {
          if (this.modelValue.user) {
            _ids = `${this.modelValue.firm}/${this.modelValue.user.user}/${this.modelValue.user.contact}`
          }
        }
      }
      console.log('ids', _ids)
      return _ids
    },
    firm() {
      let _id = null
      if (this.modelValue) {
        _id = this.modelValue.firm
      }
      return _id
    },
    isInsurer() {
      let _is = false
      if (this.user) {
        if (this.user.firmClass === 1) {
          _is = true
        }
      }
      return _is
    },
    isAdd() {
      let _is = false
      if (this.modelValue) {
        if (this.modelValue.isAdd) {
          _is = true
        }
      }
      return _is
    },
    isEdit() {
      let _is = false
      if (this.modelValue) {
        if (!this.modelValue.isAdd) {
          _is = true
        }
      }
      return _is
    },
    contactData() {
      let _data = null
      if (this.contact) {
        _data = {
          firm: this.contact.firm,
          contact: this.contact.contact
        }
      }
      return _data
    }
  },
  methods: {
    ...mapActions(userStore, ['setUser']),
    close() {
      this.isSave = false
      this.currentUserTab = 'Basic'
      this.$emit('closing')
    },
    setUserTab(value) {
      this.currentUserTab = value
    },
    saved() {
      this.isSave = false
      this.isSaving = false
    },
    changed() {
      this.isSave = true
    },
    changePassword() {
      let data = {
        firstName: this.user.firstName,
        lastName: this.user.lastName,
        user: this.user.user,
        username: this.user.username
      }
      this.$emit('changePassword', data)
    },
    moved() {
      this.$emit('moved')
    },
    async save(closeIt) {
      this.message = null
      let response = null
      this.isSaving = true
      if (this.currentUserTab === 'Basic') {
        response = await this.$refs.user.save()
      } else if (this.currentUserTab === 'Locations') {
        response = await this.$refs.locations.save()
      }
      this.isSaving = false
      this.isSave = false
      if (response.valid) {
        this.isSave = false
        this.$emit('saved', response)
        if (closeIt) {
          this.currentUserTab = 'Basic'
          this.$emit('closing')
        }
      } else {
        this.message = response.msg
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-header {
  width: 100%;
}

.custom-textarea {
  height: 200px;
}

.custom-close {
  float: right;
  margin-right: 10px;
  color: #000;
  cursor: pointer;
}

.custom-footer {
  width: 100%;
  display: inline-flex;
}

.custom-right-align {
  text-align: right;
}

.hostWrapper {
  max-height: 650px;
  overflow-x: hidden;
  overflow-y: auto;
  height: 600px;
}
</style>
